// Generic imports
import styled from "styled-components"

// Static imports

export const StyledForm = styled.form`
  .publish-class {
    padding-top: 0;
    padding-bottom: 10px;
    display: block;

    .publish-btn-wrapper {
      display: flex;
      align-items: center;
      padding-bottom: 10px;

      h5 {
        margin-right: 10px;
        margin-bottom: 5px;
      }

      button {
        width: 260px;
        border-radius: 8px;
        height: 46px;
        margin-left: 10px;
      }
    }
  }

  .contact-input {
    display: flex;
    align-items: center;
    padding-top: 15px;

    h5 {
      width: 200px;
    }
  }

  .class-logo {
    border: none;
    margin-bottom: 30px;
  }

  .poster-photo {
    white-space: initial;
  }

  .tentang-kelas img {
    padding: 0;
  }

  .poster-photo {
    display: grid;
  }

  .poster-photo > * {
    grid-area: 1/1;
  }

  .poster-photo .fileContainer,
  .poster-photo .taman-image-upload,
  .poster-photo .fileUploader {
    width: 100%;
    height: 100%;
  }

  .top-class .tags {
    padding-top: 0;
  }

  .top-class .tags h5 {
    padding-top: 12px;
    padding-bottom: 0;
  }

  .invite-tutor {
    display: flex;

    button {
      border-radius: 8px;
    }
  }

  .tempat-tgl {
    padding-top: 12px;
  }

  .tutup-pendaftaran {
    padding-top: 12px;
  }

  input,
  textarea,
  select {
    width: 100%;
    border: none;
  }

  .schedule-maker label {
    color: black;
    padding-top: 12px;
  }

  @media (max-width: 767px) {
  }
`
